import { motion } from 'framer-motion';
import React from 'react';

type PropertyItemTransitionProps = {
  delay: number;
  children: React.ReactNode;
};

export const PropertyItemTransition: React.FC<PropertyItemTransitionProps> = ({ children, delay }) => (
  <motion.div
    initial={{ position: 'relative' }}
    animate={{ opacity: [0, 1], top: ['20px', '0px'] }}
    transition={{
      delay: delay,
      duration: 0.5,
      ease: 'backInOut',
    }}
    exit={{ opacity: 0 }}>
    {children}
  </motion.div>
);
